// extracted by mini-css-extract-plugin
export var accordion = "_bb-0";
export var chevron = "_bb-3";
export var closed = "_bb-2";
export var content = "_bb-4";
export var open = "_bb-1";
export var rotate = "_bb-5";